'use client'
import React from 'react';
import Image from 'next/image';

type ProductCardProps = {
  categoryId: string;
  name: string;
  price: number;
  imageUrl: string;
};

const ProductCard: React.FC<ProductCardProps> = ({ categoryId, name, price, imageUrl }) => (
  <div className="group shadow-2xl bg-[rgba(249,115,22,0.1)] rounded-xl py-2 px-1 flex flex-col w-[17rem] h-[19rem]">
    <div className="overflow-hidden rounded-xl border-[0.5px] border-[rgb(249,115,22)] mb-4 h-[200px]">
      <Image
        src={imageUrl}
        alt={`${name} Product Card`}
        width={420}
        height={320}
        className="w-full h-full object-cover transition-transform duration-300 ease-in-out group-hover:scale-110"
        priority
      />
    </div>
    <h2 className="text-[18px] sm:text-[14px] font-bold text-center mb-[15px] line-clamp-2 text-white">{name}</h2>

    <a href={`/products/` + categoryId} className="text-[16px] sm:text-[14px] py-3 text-center font-bold text-white border-[0.5px] border-[rgba(249,115,22,0.25)] bg-[rgba(249,115,22,0.25)] rounded-lg hover:bg-[rgb(249,115,22)] transition-all duration-[0.2s] ease-linear mt-auto text-white">Buy | ${price.toFixed(2)}</a>
  </div>
);

export default ProductCard;
